import React from "react";

import { Box, Stack, Typography } from "@mui/material";

interface RecordingIndicatorProps {
  isRecording: boolean;
}

const RecordingIndicator: React.FC<RecordingIndicatorProps> = ({ isRecording }) => {
  if (!isRecording) return null;

  return (
    <Stack
      direction="row"
      alignItems="center"
      gap={1}
      sx={{
        px: 1.5,
        py: 0.75,
        ml:2,
        borderRadius: 999,
        border: 1,
        borderColor: "error.light",
        bgcolor: "error.lighter",
      }}
    >
      <Box
        sx={{
          width: 8,
          height: 8,
          borderRadius: "50%",
          bgcolor: "error.main",
          animation: "recordingPulse 1.4s ease-in-out infinite",
          "@keyframes recordingPulse": {
            "0%, 100%": {
              opacity: 1,
              transform: "scale(1)",
            },
            "50%": {
              opacity: 0.45,
              transform: "scale(0.85)",
            },
          },
        }}
      />
      <Typography
        variant="text14B"
        sx={{
          color: "error.dark",
          whiteSpace: "nowrap",
        }}
      >
        Recording
      </Typography>
    </Stack>
  );
};

export default RecordingIndicator;
